import React from 'react'
import { connect } from "react-redux";
import PowerbiEmbedded from "react-powerbi";
import {
    fetchReports
} from '../../../../store/actions/reportsAction'

class GlobalDashboard extends React.Component{

    constructor(props){
        super(props);
        this.props.fetchReports('b8388a72-c3ac-4281-8d96-86b14192123d');
        this.state = {
            reportID: 'b8388a72-c3ac-4281-8d96-86b14192123d',
            user: this.props.user,
             token: {}
        }
        const {user, reportID} = this.state;
        user && this.props.fetchReports({reportID, user});
    }

    componentWillReceiveProps(nextProps, prevProps){
        if(nextProps.token){
            if(nextProps.token !== this.state.token){
                this.setState({
                    token: nextProps.token,
                    user: nextProps.user
                });
                
            }
        }
    }

    render(){
        const { token, user } = this.state;
        const { reportID } = this.state;
        return(
            <div style={{width: '100%', padding: 0, height: 'calc( 100vh - 60px )'}}>
                {token && <PowerbiEmbedded
                    id={`${reportID}`}
                    userId={ user.userId }
                    embedUrl={token.embedUrl}
                    accessToken={token.accessToken}
                    filterPaneEnabled={true}
                    navContentPaneEnabled={true}
                    tokenType='Embed'
                    width="100%"
                    height="100%"
                />}
            </div>
        )
    }
}

const mapStateToProps = state => ({
    token: state.token.token,
    user: state.auth.user
})

export default connect(mapStateToProps, {
    fetchReports
})(GlobalDashboard);